import React, { lazy, Suspense } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import Route from './Route';
import PageLoader from '../components/PageLoader';

// Mantém estático: é a primeira tela carregada antes de qualquer auth
import SignIn from '../pages/SignIn';

// Rotas públicas — carregam sob demanda
const SignUp = lazy(() => import('../pages/SignUp'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const VerifyEmail = lazy(() => import('../pages/VerifyEmail'));
const ResendVerifyEmail = lazy(() => import('../pages/ResendVerifyEmail'));

// Rotas privadas — carregam sob demanda
const Dashboard = lazy(() => import('../pages/Dashboard'));
const Animals = lazy(() => import('../pages/Animals'));
const NewPost = lazy(() => import('../pages/NewPost'));
const PostImages = lazy(() => import('../pages/PostImages'));
const MyPosts = lazy(() => import('../pages/MyPosts'));
const EditPost = lazy(() => import('../pages/EditPost'));
const EditPostImages = lazy(() => import('../pages/EditPostImages'));
const Profile = lazy(() => import('../pages/Profile'));
const AdminModeration = lazy(() => import('../pages/AdminModeration'));
const AboutAdopet = lazy(() => import('../pages/AboutAdopet'));
const SupportProject = lazy(() => import('../pages/SupportProject'));

const Routes: React.FC = () => (
  <Suspense fallback={<PageLoader />}>
    <Switch>
      <Route path="/login" exact component={SignIn} guestOnly />
      <Route path="/signup" component={SignUp} guestOnly />
      <Route path="/forgot" component={ForgotPassword} guestOnly />
      <Route path="/password/reset" component={ResetPassword} guestOnly />
      <Route path="/verify-email" exact component={VerifyEmail} guestOnly />
      <Route path="/resend-verify-email" exact component={ResendVerifyEmail} guestOnly />

      <Route path="/" exact component={Dashboard} />
      <Route path="/new-post" component={NewPost} isPrivate />
      <Route path="/post-images/:id" component={PostImages} isPrivate />
      <Route path="/animals" component={Animals} />
      <Route path="/profile" component={Profile} isPrivate />
      <Route path="/my-posts" component={MyPosts} isPrivate />
      <Route path="/admin/moderation" component={AdminModeration} isPrivate />
      <Route path="/posts/:id" component={EditPost} isPrivate />
      <Route path="/edit-post-images/:id?" component={EditPostImages} isPrivate />
      <Route path="/about" component={AboutAdopet} isPrivate />
      <Route path="/doacoes" component={SupportProject} isPrivate />

      <Redirect to="/" />
    </Switch>
  </Suspense>
);

export default Routes;
